(function(){
  var zoneInstance;

  PegasusTemplate.ActivePortionControlView = Em.View.extend({
    classNames: ['vr-active-portion'],
    templateName: 'controls/active_portion_control',
    didInsertElement: function(){
      this._super();
      this.get('controller').set('view', this);
    },

    didChangeFocus: function(){
      var row = this.get('controller.row');
      if ( !this.$() ) { return; }

      if ( !row ) {
        this.$().hide();
        return;
      }

      var zoom = this.get('controller.zoomValue');

      this.$().show();

      var left = row.$().position().left;
      var top = row.$().position().top;

      var actualLeft = ((100*left) / (zoom*100)) * 100;
      var actualTop = ((100*top) / (zoom*100)) * 100;

      this.$().css({
        top: actualTop,
        left: actualLeft,
        width: row.$().width(),
        height: row.$().height()
      });
    }.observes('controller.row'),

    contentView: Em.ContainerView.extend({
      childViews: ['topView', 'bottomView'],
      topView: Em.View.extend({
        classNames: ['vr-apc', 'vr-apc-top'],
        dragEnter: function(){
          this.set('controller.active', null);

          $('.vr-row-target-above,.vr-row-target-below').
            removeClass('vr-row-target-above').
            removeClass('vr-row-target-below');

          var row = this.get('controller.row');
          if ( window.vrDraggingRowIndex >= 0 &&  (PegasusTemplate.blockRegionInstance.indexOf( row ) - 1) === window.vrDraggingRowIndex ) {
            return;
          }
          if ( ! window.vrDragging || (window.vrDragging.id !== row.get('elementId')) ) {
            this.set('controller.active', 'top');
            row.$().addClass('vr-row-target-above');
          }
        }
      }),
      bottomView: Em.View.extend({
        classNames: ['vr-apc', 'vr-apc-bottom'],
        dragEnter: function(ev){
          this.set('controller.active', null);

          $('.vr-row-target-above,.vr-row-target-below').
            removeClass('vr-row-target-above').
            removeClass('vr-row-target-below');

          var row = this.get('controller.row');
          if ( window.vrDraggingRowIndex >= 0 && (PegasusTemplate.blockRegionInstance.indexOf( row ) + 1) === window.vrDraggingRowIndex ) {
            return;
          }

          if ( ! window.vrDragging || (window.vrDragging.id !== row.get('elementId')) ) {
            this.set('controller.active', 'bottom');
            row.$().addClass('vr-row-target-below');
          }
        }
      })
    })
  });
})();
